import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideHttpClient } from '@angular/common/http';

export const appConfig: ApplicationConfig = {
  providers: [
    // Enable zoneless change detection (no Zone.js required)
    provideZonelessChangeDetection(),
    // Provide HttpClient for API calls
    provideHttpClient(),
  ],
};
